import React, { useState, useEffect } from 'react';
import { format, addDays, formatISO, addMonths } from 'date-fns';

import { passBusinessDays } from '@/types/subscriptions/subscription';
import { REMOTEST_MONTHS } from '@/constants';
import { StartsOnView } from '@/components/pages/Subscription/Presentation/Form/Field/StartsOn/StartsOnView';
import { normalizeStartsOn } from '@/store/organization/subscription/utils';
import { SERVICE_GROUP_ID } from '@/constants';

const nowDate = new Date();
const minDate = new Date(formatISO(addDays(nowDate, passBusinessDays())));
const defaultMaxDate = new Date(formatISO(addMonths(nowDate, REMOTEST_MONTHS)));
const hodaiplusMaxDate6Month = new Date(formatISO(new Date('2026-02-01')));
const hodaiplusMaxDate12Month = new Date(formatISO(new Date('2025-08-01')));
const embaMaxDate = new Date(formatISO(new Date('2026-05-01')));
export const getMaxDate = (date1: Date, date2: Date): Date => {
  return date1 < date2 ? date1 : date2;
};

type Props = {
  value: string;
  dateFormat: string;
  error?: string;
  onChange: (value: string, touched: boolean) => void;
  serviceGroupId: number;
  serviceId: number[];
};

export const StartsOnContainer: React.FC<Props> = ({
  value,
  dateFormat,
  error,
  onChange,
  serviceGroupId,
  serviceId,
}) => {
  const [initialized, setInitialized] = useState(false);
  const [startsOn, setStartsOn] = useState<Date>(
    value ? new Date(normalizeStartsOn(value)) : minDate,
  );

  const maxDate = (() => {
    // 各サービスの開講日の最大日付を設定
    switch (serviceGroupId) {
      case SERVICE_GROUP_ID.emba:
        return getMaxDate(defaultMaxDate, embaMaxDate);
      case SERVICE_GROUP_ID.hodaiplus:
        if (serviceId.includes(23)) {
          return getMaxDate(defaultMaxDate, hodaiplusMaxDate6Month);
        } else if (serviceId.includes(25)) {
          return getMaxDate(defaultMaxDate, hodaiplusMaxDate12Month);
        } else {
          return defaultMaxDate;
        }
      default:
        return defaultMaxDate;
    }
  })();

  useEffect(() => {
    onChange(format(startsOn, dateFormat), false);
    setInitialized(true);
  }, [dateFormat, onChange, startsOn]);

  useEffect(() => {
    if (initialized) {
      setStartsOn(startsOn);
      onChange(format(startsOn, dateFormat), true);
    }
  }, [startsOn, dateFormat, initialized, onChange]);

  const childProps = {
    minDate,
    maxDate,
    dateFormat,
    error,
    startsOn,
    setStartsOn,
    serviceGroupId,
  };
  return <StartsOnView {...childProps} />;
};
